export const iconFontAwesomeBuildingsSynagogue = (
	<i className="fa-solid fa-synagogue"></i>
);
